"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var data;
        (function (data_1) {
            var mapEntry;
            (function (mapEntry) {
                class InitArgs {
                    constructor() {
                        this.userLatLon = appn.emptyString;
                    }
                }
                const _entryLayers = [];
                let _initArgs;
                let _map;
                function init(args) {
                    _initArgs = args;
                    const availableHeight = $('#content').height();
                    let setHeight = (availableHeight === undefined) ? 200 : availableHeight;
                    setHeight -= 10;
                    $('#map').height(setHeight);
                    initMap();
                }
                mapEntry.init = init;
                appn.pubSub.subscribe(appn.pubSub.WINDOW_RESIZED, function (channel, data) {
                    if (!_map)
                        return;
                    _map.invalidateSize();
                });
                function initMap() {
                    _map = appn.ui.mapInit('map', 0, 0, 11, false);
                    const userLatLon = _initArgs.userLatLon.split(',');
                    const userLat = userLatLon[0];
                    const userLon = userLatLon[1];
                    let lastEntryLatLng = new L.LatLng(userLat, userLon);
                    let lastPopup;
                    $('#entryData .infoField').each(function (index) {
                        const display = $(this).find('.displayText');
                        const lat = display.data('lat');
                        const lon = display.data('lon');
                        if (lat !== 0 && lon !== 0) {
                            const entriesll = new L.LatLng(lat, lon, 1);
                            const icon = L.divIcon({
                                html: '<div class="appn-mapPin"></div><div class="appn-mapShadow"></div>'
                            });
                            const entriesmark = new L.Marker(entriesll, { icon: icon });
                            _map.addLayer(entriesmark);
                            _entryLayers.push(entriesmark);
                            const popupText = `<div class="appnMapPopup">
                                    <h5>Captured Here</h5>${display.text().trim()}
                                    <span class="text-muted leaflet-popup-gpsstring">
                                    <i class="fa fa-map-marker"></i> ${lat} ${lon}</span><br>
                                </div>`;
                            lastPopup = entriesmark.bindPopup(popupText);
                            lastEntryLatLng = entriesll;
                            lastPopup.openPopup();
                        }
                    });
                    _map.setView(lastEntryLatLng, 13);
                }
            })(mapEntry = data_1.mapEntry || (data_1.mapEntry = {}));
        })(data = views.data || (views.data = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
